import { useContext } from 'react';
import {
  AuthContext,
  BookingContext,
  AppContext,
  ExperienceBookingContext,
  LanguageContext,
} from 'contexts';

export const useAuth = () => {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error(`useAuth must be used within an AuthProvider`);
  }

  return context;
};

export const useApp = () => {
  const context = useContext(AppContext);

  if (context === undefined) {
    throw new Error(`useApp must be used within an AppProvider`);
  }

  return context;
};

export const useBooking = () => {
  const context = useContext(BookingContext);

  if (context === undefined) {
    throw new Error(`useBooking must be used within an BookingContext`);
  }

  return context;
};

export const useExperienceBooking = () => {
  const context = useContext(ExperienceBookingContext);

  if (context === undefined) {
    throw new Error(
      `useExperienceBooking must be used within an ExperienceBookingContext`,
    );
  }

  return context;
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);

  if (context === undefined) {
    throw new Error(`useLanguage must be used within an LanguageContext`);
  }

  return context;
};
